
export const ENTRIES_UPDATE_STATE = "ENTRIES_UPDATE_STATE";
export const ENTRIES_RESET_STATE = "ENTRIES_RESET_STATE";
export const RESET_PAGE = "RESET_PAGE";